// React
import React from 'react';
import PropTypes from 'prop-types';

// Stylesheets
import './style.sass';

// Utils
import { getS3File, getS3FallbackSrc } from 'utils/s3Upload';

// Helper function to handle image imports
const getImageUrl = (imageModule) => {
  if (typeof imageModule === 'string') {
    return imageModule;
  }
  if (imageModule && typeof imageModule === 'object') {
    return imageModule.default || imageModule;
  }
  return '';
};

class Image extends React.Component {
  render() {
    const { uri, style, className, fallbackUri: fallbackProp, ...props } = this.props;

    // Add validation to ensure uri is a string
    if (!uri || typeof uri !== 'string') {
      return (
        <div
          style={style}
          className={`image ${className || ''}`}
          {...props}
        >
          {this.props.children}
        </div>
      );
    }

    const local = uri.includes('blob:') || uri.includes('static') || uri.includes('imgur');
    const resolvedUri = local ? uri : getS3File(uri);
    const fallbackUri = fallbackProp || getS3FallbackSrc(uri);
    const backgroundImage = fallbackUri
      ? `url(${resolvedUri}), url(${fallbackUri})`
      : `url(${resolvedUri})`;
    const _style = { backgroundImage };

    return (
      <div
        style={{ ..._style, ...style }}
        className={`image ${className || ''}`}
        {...props}
      >
        {this.props.children}
      </div>
    );
  }
}

Image.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  uri: PropTypes.string,
  fallbackUri: PropTypes.string,
  cache: PropTypes.number,
};

export default Image;
export { getImageUrl };
